var map = {
	"./barrating/barrating.js": 16,
	"./catalog-menu/catalog-menu.js": 17,
	"./dropdown/dropdown.js": 18,
	"./header/header.js": 19,
	"./last-comments/last-comments.js": 20,
	"./main-menu/main-menu.js": 21,
	"./medicine-data/medicine-data.js": 22,
	"./medicine-description/medicine-description.js": 23,
	"./medicine-order/medicine-order.js": 24,
	"./mobile-menu-trigger/mobile-menu-trigger.js": 25,
	"./mobile-menu/mobile-menu.js": 26,
	"./modal/modal.js": 27,
	"./page/page.js": 28,
	"./phone-input/phone-input.js": 29,
	"./readmore/readmore.js": 30,
	"./slider-navigation/slider-navigation.js": 31,
	"./spinner/spinner.js": 32,
	"./tooltip/tooltip.js": 33
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;


//////////////////
// WEBPACK FOOTER
// G:/RABOTA/satpharma/dev/source/modules ^[^\_]*\.js
// module id = 15
// module chunks = 0